import {
  Component,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core';
import { CommonModule } from '@angular/common';

export interface NewRoofCostTestimonial {
  quote: string;
  name: string;
  location: string;
}

@Component({
  selector: 'app-new-roof-cost-testimonials',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule],
  templateUrl: './new-roof-cost-testimonials.component.html',
  styleUrl: './new-roof-cost-testimonials.component.scss',
})
export class NewRoofCostTestimonialsComponent implements AfterViewInit {
  @ViewChild('swiperRef') swiperRef!: ElementRef<HTMLElement>;

  trackByName = (_: number, t: NewRoofCostTestimonial) => t.name;
  trackByIndex = (i: number) => i;
  atStart = true;
  atEnd = false;

  testimonials: NewRoofCostTestimonial[] = [
    {
      name: "Logan O'Malley",
      location: 'Tampa, Florida',
      quote:
        "I was stressed trying to figure out the cost to redo my roof until a friend pointed me to NestBuilder. I plugged in asphalt shingles as my material and instantly got a price range of $12,000-$15,000. Best part? It also showed me the best roofers near me so I could get started right away.",
    },
    {
      name: 'Chris Richards',
      location: 'Flemmington, New Jersey',
      quote:
        "Nestbuilder is easy to use and gives you a broad range of options to look at and the ability to modify the estimate based upon what you know about your roof that can't be readily seen from the eye in the sky photos...very nice tool",
    },
    {
      name: 'Casey Mahoney',
      location: 'Spooner, Wisconsin',
      quote:
        "I used this site to get a roofing estimate and found it really straightforward. The estimate came quickly, and the details helped me understand what to expect for roof repair costs in my area. It's a simple way to compare roofing prices without having to call multiple contractors.",
    },
    {
      name: 'Cole Bittel',
      location: 'San Dimas, California',
      quote: 'The Nestbuilder team helped me find an affordable, high quality roofer!',
    },
    {
      name: 'Ryan Howard',
      location: 'Cuero, Texas',
      quote:
        "The process was straightforward and simple. Found a roofer for my project in no time. Thank you!",
    },
  ];

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    if (typeof window === 'undefined') return;
    const el = this.swiperRef?.nativeElement as HTMLElement & {
      initialize?: () => void;
      swiper?: { isBeginning: boolean; isEnd: boolean };
    };
    if (!el || typeof el.initialize !== 'function') return;

    const params = {
      spaceBetween: 24,
      slidesPerView: 1,
      breakpoints: {
        768: { slidesPerView: 2 },
        992: { slidesPerView: 3 },
      },
      on: {
        init: () => {
          this.updateBounds(el);
          this.cdr.markForCheck();
        },
        slideChange: () => {
          this.updateBounds(el);
          this.cdr.markForCheck();
        },
      },
    };
    Object.assign(el, params);
    setTimeout(() => {
      if (el.children.length > 0 && typeof el.initialize === 'function') el.initialize();
    }, 100);
  }

  private updateBounds(el: HTMLElement & { swiper?: { isBeginning: boolean; isEnd: boolean } }): void {
    const swiper = el.swiper;
    if (!swiper) return;
    this.atStart = swiper.isBeginning;
    this.atEnd = swiper.isEnd;
  }

  prev(): void {
    const el = this.swiperRef?.nativeElement as HTMLElement & { swiper?: { slidePrev: () => void } };
    if (!el?.swiper || this.atStart) return;
    el.swiper.slidePrev();
  }

  next(): void {
    const el = this.swiperRef?.nativeElement as HTMLElement & { swiper?: { slideNext: () => void } };
    if (!el?.swiper || this.atEnd) return;
    el.swiper.slideNext();
  }
}
